<template>
    <div>
        <base_aggregator
            @edit_location="edit_location"
            @get_json="get_json"
            @show_menu="show_menu"
            @make_sync="make_sync"
            @add_location="add_location"
            @head_action="head_action"
            :provider_id=this.provider_id
            provider_type="shopify"
        />
        <shipday_location_modal></shipday_location_modal>
    </div>
</template>

<script>


import base_aggregator from "../base/base_aggregator";
import shipday_location_modal from "./location/shipday_location_modal";
import {mapGetters} from "vuex";

export default {
    name: "shipday_export",
    props : {
        provider_id: {
            type: Number,
            required: true,
        },
    },

    components : {
        base_aggregator,
        shipday_location_modal
    },
    created() {
        EventBus.$on('loaded_api',this.load_provider);
        EventBus.$on('reload_provider',this.load_provider);
        if(window.hasOwnProperty('agr_api')) {
            this.load_provider();
        }
    },

    methods: {
        head_action() {

        },

        make_sync(location) {

        },

        show_menu(location) {

        },

        get_json(location) {

        },

        edit_location(location) {
            EventBus.$emit("location_edit",{
                'org_id' : 0,
                'org_obj' : null,
                'location_id' : location.id,
                'provider_id' : this.provider_id
            });
        },

        add_location(organization) {
            EventBus.$emit("location_edit",{
                'org_id' : organization.id,
                'org_obj' : organization,
                'location_id' : 0,
                'provider_id' : this.provider_id
            });
        },

        load_provider() {
            this.$store.dispatch('aggregator/LOAD_OUT_PROVIDER',this.provider_id);
        }
    },

    computed : {
        ...mapGetters({
            'aggregator'        : "aggregator/getAggregator",
            'is_load_complete'  : "aggregator/is_load_complete"
        }),
    }
}
</script>

<style scoped>

</style>
